import { render, staticRenderFns } from "./IconGifTab.vue?vue&type=template&id=59cecca1"
import script from "./IconGifTab.vue?vue&type=script&lang=js"
export * from "./IconGifTab.vue?vue&type=script&lang=js"
import style0 from "./IconGifTab.vue?vue&type=style&index=0&id=59cecca1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports